import {applyMiddleware, combineReducers,createStore} from "redux"
import { composeWithDevTools } from '@redux-devtools/extension';
import  {thunk}  from "redux-thunk"
import authReducer from "./reducers/auth";

const initialState = {
  auth: {
    auth: localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : null
  }
}

const reducers= combineReducers({
  auth:authReducer
})

const store = createStore(reducers,initialState,composeWithDevTools(applyMiddleware(thunk)));


export default store;